import { Sun, Moon } from "lucide-react";
import { useTheme } from "../theme/ThemeContext";

export default function ThemeToggle({ className = "", testid = "theme-toggle" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      data-testid={testid}
      onClick={toggle}
      title={isDark ? "Switch to light background" : "Switch to dark background"}
      aria-label="Toggle background color"
      className={
        "inline-flex items-center gap-1.5 px-3 h-9 rounded-lg border border-[var(--al-border)] bg-[var(--al-card-bg)] text-[12.5px] font-semibold text-[var(--al-text)] hover:border-[#3B82F6] hover:text-[#3B82F6] transition-colors " +
        className
      }
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
      <span>{isDark ? "Light" : "Dark"}</span>
    </button>
  );
}
